import React, { Component, } from 'react';
import PropTypes from 'prop-types';
import ChatBot, { Loading } from 'react-simple-chatbot';
import ChatBotService from "../../services/chatbot.service";
import Validation from "../utils/Validation";

export default class VerifyCoAffiliate extends Component {
  constructor(props) {
    super(props);

    this.state = {
        loading: true,
        result: '',
    };
  }

  componentDidMount(){
    this.VerifyCoAffiliate();
  }

  async VerifyCoAffiliate(){

    let data = {
        nroDocument: localStorage.getItem("userDNI")
    }

    ;

    let response = await ChatBotService.VerifyCoAffiliate(data);
    
    if(response != undefined){
        if(response.status == 1){
            if(response.objModel == true){
                this.setState({
                    loading: false,
                    result: 'Perfecto. Hemos comprobado que cuenta con co-afiliado.'
                })
                this.triggertNext();
            }else {
                this.setState({
                    loading: false,
                    result: 'Usted no cuenta con co-afiliado.'
                })
                this.triggertNextFalse();
            }
        }else{
            this.setState({
                loading: false,
                result: 'Error al obtener información de usuario.'
            })
            this.triggertNextError();
        }
    }else{
        this.setState({
            loading: false,
            result: 'Error al obtener información de usuario.'
        })
        this.triggertNextError();
    }

    /// end
  }

  triggertNext() {
    this.setState({ trigger: true }, () => {
      

      this.props.triggerNextStep({trigger: "5a"});
    });
  }

  triggertNextFalse() {
    this.setState({ trigger: true }, () => {
      

      this.props.triggerNextStep({trigger: "final4"});
    });
  }

  triggertNextError() {
    this.setState({ trigger: true }, () => {
      

      this.props.triggerNextStep({trigger: "7a"});
    });
  }


  render() {
      const {loading, result} = this.state;

    return (
      <div className="dbpedia" style={{color: '#fff'}}>
        { loading ? <Loading /> : result }

      </div>
    );
  }

}